import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useClientStore } from "@/stores/clients";
import { Client } from "@/types";
import NavigateBack from "@/components/ds/navigate-back/NavigateBack.vue";
import { useDebounceFn } from "@vueuse/core";
import api from "@/api";
import Panel from "@/components/general/Panel.vue";
import ClientDetails from "@/components/pages/client/ClientDetails.vue";
import { useUiStore } from "@/stores/ui";
import ClientSecondary from "@/components/pages/client/ClientSecondary.vue";
import ClientTools from "@/components/pages/client/ClientTools.vue";
import Cols from "@/components/general/Cols.vue";
import ItemPage from "@/components/general/ItemPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();
const clientsStore = useClientStore();

const client = ref<Client | null>(null);
const watchActive = ref(false);

const atBack = () => {
    router.push({ name: "Clients" });
};

const debouncedFn = useDebounceFn(() => {
    if (client.value) {
        api.update(client.value, "clients").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

watch(
    () => client.value,
    () => {
        if (watchActive.value) {
            debouncedFn();
        }
    },
    { deep: true }
);

onMounted(() => {
    const slug = route.params.slug as string;
    const clientId = Number(slug.split("-")[0]);
    const c = clientsStore.list.find((client: Client) => client.id == clientId);
    if (c) {
        client.value = c;
        setTimeout(() => {
            watchActive.value = true;
        });
    } else {
        router.push({ name: "Clients" });
    }
});

return (_ctx: any,_cache: any) => {
  return (client.value)
    ? (_openBlock(), _createBlock(ItemPage, { key: 0 }, {
        header: _withCtx(() => [
          _createVNode(NavigateBack, { onClick: atBack }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Terug naar klanten ")
            ])),
            _: 1
          })
        ]),
        cols: _withCtx(() => [
          _createVNode(Panel, { title: "Primair" }, {
            default: _withCtx(() => [
              _createVNode(ClientDetails, { client: client.value }, null, 8, ["client"])
            ]),
            _: 1
          }),
          _createVNode(Panel, { title: "Secundair" }, {
            default: _withCtx(() => [
              _createVNode(ClientSecondary, { client: client.value }, null, 8, ["client"])
            ]),
            _: 1
          }),
          _createVNode(ClientTools, { client: client.value }, null, 8, ["client"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})